import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectionStrategy,
} from "@angular/core";
import { ChildrenOutletContexts, Router } from "@angular/router";
import { Subscription } from "rxjs";
import {
  transition,
  trigger,
  animate,
  group,
  query,
  style,
} from "@angular/animations";

@Component({
  selector: "app-agent",
  templateUrl: "./agent.component.html",
  styleUrls: ["./agent.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger("routeAnimations", [
      transition("AgentDashboardComponent => PatientComponent", [
        style({ position: "relative" }),
        query(
          ":enter, :leave",
          style({
            position: "absolute",
            top: "0",
            left: "0",
            width: "100%",
            height: "100%",
          }),
          { optional: true },
        ),

        group([
          // Block executes in parallel
          query(
            ":enter",
            [
              style({ transform: "translateX(100%)", opacity: 0 }),
              animate(
                "1.5s ease-in-out",
                style({ transform: "translateX(0%)", opacity: 1 }),
              ),
            ],
            { optional: true },
          ),
          query(
            ":leave",
            [
              style({ transform: "translateX(0%)", opacity: 1 }),
              animate(
                "1.5s ease-in-out",
                style({ transform: "translateX(-100%)", opacity: 0 }),
              ),
            ],
            { optional: true },
          ),
        ]),
      ]),
      transition("PatientComponent => AgentDashboardComponent", [
        style({ position: "relative" }),
        query(
          ":enter, :leave",
          style({
            position: "absolute",
            top: "0",
            left: "0",
            width: "100%",
            height: "100%",
          }),
          { optional: true },
        ),
        group([
          // Block executes in parallel
          query(
            ":enter",
            [
              style({ transform: "translateX(-100%)", opacity: 0 }),
              animate(
                "1.5s ease-in-out",
                style({ transform: "translateX(0%)", opacity: 1 }),
              ),
            ],
            { optional: true },
          ),
          query(
            ":leave",
            [
              style({ transform: "translateX(0%)", opacity: 1 }),
              animate(
                "1.5s ease-in-out",
                style({ transform: "translateX(100%)", opacity: 0 }),
              ),
            ],
            { optional: true },
          ),
        ]),
      ]),
    ]),
  ],
})
export class AgentComponent implements OnInit, OnDestroy {
  // TODO: Remove this once we have a real user
  userDetails: any;
  userProviders: any;
  private readonly subscriptions: Subscription = new Subscription();

  constructor(private contexts: ChildrenOutletContexts) {
    const pageTitle = document.getElementById("pageTitle") as HTMLElement;
    pageTitle.innerText = "HolaDOC Agente";
  }

  ngOnInit(): void {}

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  getRouteAnimationData() {
    return this.contexts.getContext("primary")?.route?.snapshot.data[
      "animation"
    ];
  }
}
